var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFlashSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25004 2.16683C3.09945 2.16683 2.16671 3.09957 2.16671 4.25015V11.7502C2.16671 12.9008 3.09945 13.8335 4.25004 13.8335H11.75C12.9006 13.8335 13.8334 12.9008 13.8334 11.7502L13.8334 4.25015C13.8334 3.09957 12.9006 2.16683 11.75 2.16683H4.25004ZM1.83337 4.25015C1.83337 2.91547 2.91535 1.8335 4.25004 1.8335H11.75C13.0847 1.8335 14.1667 2.91547 14.1667 4.25015L14.1667 11.7502C14.1667 13.0849 13.0847 14.1668 11.75 14.1668H4.25004C2.91535 14.1668 1.83337 13.0849 1.83337 11.7502V4.25015ZM8.00004 4.83348C8.09209 4.83348 8.16671 4.9081 8.16671 5.00015V8.00013C8.16671 8.09218 8.09209 8.1668 8.00004 8.1668C7.90799 8.1668 7.83337 8.09218 7.83337 8.00013V5.00015C7.83337 4.9081 7.90799 4.83348 8.00004 4.83348ZM8.00004 10.0571C8.09209 10.0571 8.16671 10.1317 8.16671 10.2237V10.2501C8.16671 10.3422 8.09209 10.4168 8.00004 10.4168C7.90799 10.4168 7.83337 10.3422 7.83337 10.2501V10.2237C7.83337 10.1317 7.90799 10.0571 8.00004 10.0571Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFlashSale);
export default __webpack_public_path__ + "static/media/ic-flash-sale.30ae016db1b46d65f77887b7ccadee1b.svg";
export { ForwardRef as ReactComponent };